export default {
  create: {
    method: 'post',
    url: '/client/quote/quote-request'
  },
  updateStatus: {
    method: 'put',
    url: '/client/journey/ID/cancel'
  },
  changePartner: {
    method: 'put',
    url: '/client/journey/ID/change-partner'
  },
  updateContainerNo: {
    method: 'put',
    url: '/client/journey/ID/container-number'
  }
}
